"use strict";
var calendar_pipe_1 = require('./calendar.pipe');
exports.CalendarPipe = calendar_pipe_1.CalendarPipe;
var date_format_pipe_1 = require('./date-format.pipe');
exports.DateFormatPipe = date_format_pipe_1.DateFormatPipe;
var difference_pipe_1 = require('./difference.pipe');
exports.DifferencePipe = difference_pipe_1.DifferencePipe;
var duration_pipe_1 = require('./duration.pipe');
exports.DurationPipe = duration_pipe_1.DurationPipe;
var from_unix_pipe_1 = require('./from-unix.pipe');
exports.FromUnixPipe = from_unix_pipe_1.FromUnixPipe;
var moment_module_1 = require('./moment.module');
exports.MomentModule = moment_module_1.MomentModule;
var time_ago_pipe_1 = require('./time-ago.pipe');
exports.TimeAgoPipe = time_ago_pipe_1.TimeAgoPipe;
var utc_pipe_1 = require('./utc.pipe');
exports.UtcPipe = utc_pipe_1.UtcPipe;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-moment/index.js
// module id = 316
// module chunks = 1